import { type FC } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';

import s from './VideoCreatorLoading.scss';
import sParent from '../VideoCreatorFiles.scss';

export interface Props {}

const VideoCreatorLoading: FC<Props> = () => {
  const { t } = useTranslation();

  return (
    <div className={cn(s['root'], sParent['file-item'])}>
      <div className={s['llama-part']}>
        <div className={s['llama-icon']}>
          <LoadingIndicator view="llama" className={s['llama-loader']} />
        </div>
        <div className={s['llama-text']}>
          {t('studio.videoCreator.results.loading')}
        </div>
      </div>
    </div>
  );
};

VideoCreatorLoading.displayName = 'VideoCreatorLoading';
export default VideoCreatorLoading;
